import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import PostForm from './PostForm'

import { storePost } from '../services'
import { handleError } from '../../../helpers'

export default function NewPostModal({ visible, onClose, reload }) {
	const { register, handleSubmit, formState: { errors } } = useForm({})
	const [selectedUser, setSelectedUser] = useState([])

	const onSubmit = values => {
		values.user_id = selectedUser.value
		storePost(values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Agregar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<PostForm 
							register={register} 
							errors={errors}
							selectedUser={selectedUser}
							setSelectedUser={setSelectedUser}
						/>
						<Button color="primary" type="submit">Agregar Registro</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}